import { useQuery } from "@tanstack/react-query";
import { getFetch } from "../utils/api";
import { TeamMember } from "../sections/team";

type TeamResponse = {
  teamMembers: TeamMember[];
};

export const useGetTeam = () => {
  return useQuery({
    queryKey: ["team"],
    queryFn: () => getFetch<TeamResponse>("team"),
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 3,
  });
};
